import React from 'react';
import { FloatingActionHub } from './FloatingActionHub';

export const ChatBox: React.FC<{ onOpenConsultation?: () => void }> = ({ onOpenConsultation }) => {
  return <FloatingActionHub onOpenConsultation={onOpenConsultation} />;
};
